import { Button, Space, Switch, Table, Tooltip, Typography } from "antd"
import Layout from "modules/layout/dashboard"
import React, { useState } from "react"
import { ReactComponent as ShowIcon } from "assets/icons/show.svg"
import { useTranslation } from "react-i18next"
import { useNavigate } from "react-router-dom"
import { useInvoices } from "./queries"
import { useMemberId } from ".."
import styles from "./styles.module.scss"
import Loader from "components/loader"
import { useMember } from "../queries"
import moment from "moment"
import { IInvoice } from "./type"
const { Main } = Layout
const { Title, Text } = Typography
const Invoices: React.FC = () => {
  const navigate = useNavigate()
  const { t } = useTranslation()
  const memberId = useMemberId()
  const member = useMember(memberId)
  const [showTrash, setShowTrash] = useState(false)

  const { data, isLoading } = useInvoices(memberId!, showTrash)

  const handleFilterClick = (checked: boolean) => {
    setShowTrash(checked)
  }
  return (
    <>
      <Main.PageHeader
        breadcrumbs={[
          {
            title: member.data?.name,
            link: `/members/${member.data?.id}/events`,
          },
          { title: t("invoice.title") },
        ]}
        title={<Title level={3}>{t("invoice.title")}</Title>}
        rightContent={
          <Space>
            <Switch onChange={handleFilterClick} />
            <Space>
              <Text strong>{t("invoice.archive")}</Text>
            </Space>
          </Space>
        }
      />
      {isLoading ? (
        <Loader />
      ) : (
        <Table<IInvoice>
          tableLayout="fixed"
          className={styles.table}
          rowKey={"id"}
          columns={[
            {
              title: t<string>("invoice.proforma_number"),
              dataIndex: "proforma_reference",
              key: "proforma_reference",
              ellipsis: true,
              render: (value) => (
                <Tooltip placement="bottomLeft" title={value}>
                  {value}
                </Tooltip>
              ),
            },
            {
              title: t<string>("invoice.number"),
              dataIndex: "reference",
              key: "reference",
              ellipsis: true,
              render: (value, record) => (
                <Tooltip
                  placement="bottomLeft"
                  title={value ?? record.proforma_reference}
                >
                  {value ?? record.proforma_reference}
                </Tooltip>
              ),
            },
            {
              title: t<string>("invoice.recipient"),
              dataIndex: ["recipient", "name"],
              key: "recipient",
              ellipsis: true,
              render: (value) => (
                <Tooltip placement="bottomLeft" title={value}>
                  {value}
                </Tooltip>
              ),
            },
            {
              title: t<string>("date.date"),
              dataIndex: "created_at",
              key: "created_at",
              ellipsis: true,
              render: (value) => {
                const displaValue = moment(value)
                  .utcOffset(0, false)
                  .format("yyyy-MM-DD")
                return (
                  <Tooltip placement="bottomLeft" title={displaValue}>
                    {displaValue}
                  </Tooltip>
                )
              },
            },
            {
              title: t<string>("invoice.due_date"),
              dataIndex: "due_date",
              ellipsis: true,
              key: "due_date",
              render: (value) => {
                const displayValue = moment(value)
                  .utcOffset(0, false)
                  .format("yyyy-MM-DD")
                return (
                  <Tooltip placement="bottomLeft" title={displayValue}>
                    {displayValue}
                  </Tooltip>
                )
              },
            },
            {
              title: t<string>("global.status"),
              dataIndex: "displayed_status",
              key: "status",
              ellipsis: true,
              render: (value) => (
                <Tooltip placement="bottomLeft" title={value}>
                  {value}
                </Tooltip>
              ),
            },
            {
              title: "Action",
              key: "action",
              width: 100,
              render: (_, record) => (
                <>
                  <Tooltip placement="bottom" title={t("global.show")}>
                    <Button
                      type="text"
                      shape="circle"
                      onClick={() => navigate(record.id)}
                      icon={<ShowIcon />}
                    />
                  </Tooltip>
                </>
              ),
            },
          ]}
          dataSource={data}
        />
      )}
    </>
  )
}

export default Invoices
